// Student's app Join tap (goserver student_app_join_ist, IST): display-only evidence on an incomplete Zoom.
const HH_MM = /(?:^|\s)(\d{1,2}):(\d{2})(?::\d{2})?$/;

// '2026-10-14 18:02' -> 'Student tapped Join in the app at 18:02 IST'; '' when absent or unreadable.
export const app_join_text = (ist) => {
  const m = typeof ist === 'string' ? ist.trim().match(HH_MM) : null;
  return m ? `Student tapped Join in the app at ${m[1].padStart(2, '0')}:${m[2]} IST` : '';
};

export const APP_JOIN_UNAVAILABLE_TEXT = 'App Join could not be checked.';

// The evidence line: a failed server read (app_join_unavailable) is "unknown", never "no tap".
export const app_join_line = (ist, unavailable = false) =>
  unavailable ? APP_JOIN_UNAVAILABLE_TEXT : app_join_text(ist);
